import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

import { rememberSearch } from '@/lib/store'

/** Search state shared by the header field and the mobile search sheet. */
export function useSearchNavigation() {
  const [params] = useSearchParams()
  const current = params.get('q') ?? ''
  const [draft, setDraft] = useState(current)
  const [synced, setSynced] = useState(current)
  const navigate = useNavigate()

  // Follow the URL (back button, tag links) without an effect round-trip.
  if (synced !== current) {
    setSynced(current)
    setDraft(current)
  }

  function submit(query: string) {
    const q = query.trim().replace(/\s+/g, ' ')
    rememberSearch(q)
    navigate(q ? `/?q=${encodeURIComponent(q)}` : '/')
  }

  return { current, draft, setDraft, submit }
}
